
import React from "react";
import classes from "./sixYardAcademy.module.css";
import Title from "../../containers/title/title";
import { getImageUrl } from "../../../utils/imageUrl";

function SixYardAcademy(props) {
    return (
        <section className={classes.Academy}>
            <Title title={props.academy?.basic_info?.name} />
            <div className={classes.DarkEffect} />
            <div className={classes.Background} style={{ backgroundImage: `url(${getImageUrl(props.academy?.basic_info?.image)})` }}>
                <div>
                    <p>{props.academy?.basic_info?.description}</p>
                    <p>{props.academy?.basic_info?.safety_note}</p>
                </div>
            </div>
        </section>
    );
}

export default SixYardAcademy;
